import API from '@/assets/libraries/API_Requests';

export async function getAudioInformation(audio_file_id) {
	return await API.Call('GET', API.CSC_API_URL + `/audio/info/${audio_file_id}`);
}

export function downloadAudioFile(audio_file_url) {
	return new Promise((resolve, reject) => {
		let audio_file_xhr = new XMLHttpRequest();
		audio_file_xhr.open('GET', audio_file_url, true);
		audio_file_xhr.responseType = 'blob';
		audio_file_xhr.onload = function () {
			const audio_file = new Blob([audio_file_xhr.response], { type: 'application/octet-stream' });
			const audio_url = URL.createObjectURL(audio_file);
			resolve(audio_url);
		};
		audio_file_xhr.onerror = function () {
			reject(new Error('export_show.error_downloading_audio_file'));
		};

		audio_file_xhr.send();
	});
}

export async function chooseAudioFileForShow(show_id, audio_file_id) {
	const response = await API.Call('PUT', API.CSC_API_URL + `/shows/${show_id}/audio/${audio_file_id}`);

	if (response.error != undefined) {
		throw new Error(response.error);
	}

	return response;
}

export async function updateAudioFile(audio_file_id, updated_audio_file_name) {
	const response = await API.Call('PUT', API.CSC_API_URL + `/audio/files/${audio_file_id}`, { name: updated_audio_file_name });

	if (response.error != undefined) {
		throw new Error(response.error);
	}

	return response;
}

export async function deleteAudio(audio_file_id) {
	return await API.Call('DELETE', API.CSC_API_URL + `/audio/files/${audio_file_id}`);
}

export async function syncAudioFileForShow(audio_file_id, timecode_channel) {
	const response = await API.Call('PUT', API.CSC_AUDIO_URL + `/audio/files/audiosync/${audio_file_id}`, { timecode_channel });

	if (response.error != undefined) {
		throw new Error(response.error);
	}

	return response;
}

export async function finalizeCompoundFileEdit({ files_to_combine = [], compound_file_name = '' }, compound_audio_file_id) {
	let response;

	if (compound_audio_file_id != undefined) {
		response = await API.Call('PUT', API.CSC_AUDIO_URL + `/audio/compound/${compound_audio_file_id}`, { file_ids: files_to_combine });
	} else {
		response = await API.Call('POST', API.CSC_AUDIO_URL + `/audio/compound`, { compound_file_name, files_to_combine });
	}

	if (response.error != undefined) {
		throw new Error(response.error);
	}

	return response;
}

export async function loadCurrentCompoundFiles(compound_audio_file_id) {
	try {
		const response = await API.Call('GET', API.CSC_API_URL + `/audio/compound/${compound_audio_file_id}`);

		if (response.error != undefined) {
			throw new Error(response.error);
		}

		return response;
	} catch (error) {
		return [];
	}
}
